import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import BlockDetails from "./pages/BlockDetails";
import TransactionDetails from "./pages/TransactionDetails";
import AddressDetails from "./pages/AddressDetails";
import { alchemy } from "./utils/alchemy";
import "./App.css";

function App() {
  const [currentBlock, setCurrentBlock] = useState(null);

  useEffect(() => {
    async function getCurrentBlock() {
      const blockNumber = await alchemy.core.getBlockNumber();
      setCurrentBlock(blockNumber);
    }
    getCurrentBlock();
  }, []);

  return (
    <Router>
      <div className="app">
        <Header currentBlock={currentBlock} />
        <main className="main">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/block/:blockNumber" component={BlockDetails} />
            <Route path="/tx/:txHash" component={TransactionDetails} />
            <Route path="/address/:address" component={AddressDetails} />
          </Switch>
        </main>
        <footer className="footer">
          <p>Powered by Alchemy SDK | Ethereum Mainnet</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
